import styles from './Spinner.module.css';

interface SpinnerProps {
  hasWrapper?: boolean;
}

const SpinnerComponent = <span className={styles.spinner} />;

export function Spinner({ hasWrapper = false }: SpinnerProps) {
  if (hasWrapper) {
    return <div className={styles.spinnerWrapper}>{SpinnerComponent}</div>;
  }

  return SpinnerComponent;
}
